export default {"src":"/_next/static/media/empty_gem.31df89b9.svg","height":69,"width":81,"blurWidth":0,"blurHeight":0};